import { Title } from '../../components/Title/Title';
import { Topbar } from '../../components/Topbar/Topbar';
import { Footer } from '../../components/Footer/Footer';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useEffect, useState } from 'react';
import { innerHtml } from '../../utils/utils';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';

const Contacts = () => {
    const { getLegal } = useFirebase();
    const { t } = useTranslation();
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getLegal('contacts')
            .then(({ content }) => {
                setContent(content);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <FullscreenLoader fullscreen={true} />;

    return (
        <>
            <Title>{t('legalese.labels.contactUs')}</Title>

            <div style={{ marginBottom: '72px' }}>
                <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
                    <Topbar />
                </div>
            </div>

            <Container className={'my-5'}>
                <div {...innerHtml(content)}></div>
            </Container>

            <Footer />
        </>
    );
};

export default Contacts;